import { Component } from '@angular/core';

@Component({
  selector: 'data-management',
  template: ` <router-outlet></router-outlet> `,
  styles: [],
})
export class DataManagementComponent {}
